"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContractBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
var _reactivity = require("@vue/reactivity");
const settings = [{
  title: "Contract",
  settings: {
    contract: {
      type: "var",
      variableType: "contract",
      title: "Contract",
      description: "Contract to use."
    }
  }
}];
class ContractBlock extends _BlockType.BlockType {
  constructor(param) {
    super();
    (0, _defineProperty2.default)(this, "type", "contract");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "contractVariable", void 0);
    this.param = param;
    let refs = (0, _reactivity.toRefs)(param);
    this.contractVariable = this.addBlockVariable(new _variables.PointerVariable(), (0, _reactivity.reactive)({
      ref: refs.contract || {
        type: "var",
        param: {
          type: "contract"
        }
      }
    }));
  }
  renderValue() {
    let contract = this.contractVariable.value();
    if (_variables.VarsContract.isVarsContract(contract === null || contract === void 0 ? void 0 : contract.value)) {
      return contract.value;
    }
    return null;
  }
}
exports.ContractBlock = ContractBlock;
(0, _defineProperty2.default)(ContractBlock, "settings", settings);
//# sourceMappingURL=ContractBlock.js.map